// extracted by mini-css-extract-plugin
export var gridItemContainer = "styles-module--gridItemContainer--DXAP3";
export var left = "styles-module--left--UXUZT";
export var center = "styles-module--center--KWnXA";
export var right = "styles-module--right--5CFR4";
export var flex = "styles-module--flex--iCPn4";
export var icon = "styles-module--icon--yZZo+";
export var text = "styles-module--text--pptH5";
export var link = "styles-module--link--nfUOl";